import React from 'react';

const CustomizedView = () => {
  return <div>CustomisedView</div>;
};

export default CustomizedView;
